<template>
    <div
        class="nav-item"
        @click="$emit('abaSelecionada', aba)"
        v-if="abaAtiva"
    >
        <div
            class="nav-link"
            :class="{ 'active': abaAtual }"
            v-b-tooltip.hover="abaEmAjuste ? 'Foi requisitado mudanças nesta aba' : null"
        >
            <span :class="{ 'text-success': abaVisualizada && !abaEmAjuste, 'text-danger font-weight-bold': abaEmAjuste }">
                {{ aba.nome }} &nbsp;
                <i
                    v-if="abaEmAjuste"
                    class='fa fa-times-circle-o'
                ></i>
                <i v-else-if="abaVisualizada" class='fa fa-check-circle-o' ></i>
                <i v-else-if="abaObrigatoria && !abaVisualizada" class='fa fa-circle-thin' ></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Aba",
    props: {
        aba: {
            type: Object,
            required: true
        },
        abaAtual: {
            type: Boolean,
            required: false,
            default: false
        },
        abaAtiva: {
            type: Boolean,
            required: false,
            default: false
        },
        abaObrigatoria: {
            type: Boolean,
            required: false,
            default: false
        },
        abaVisualizada: {
            type: Boolean,
            required: false,
            default: false
        },
        abaEmAjuste: {
            type: Boolean,
            required: false,
            default: false
        },
    }
};
</script>
